import styled from 'styled-components'

export const Container = styled.main`
  background: #fff;
  padding: 50px 100px;
  display: flex;
  flex-direction: column;
  max-width: 700px;
  margin: 0 auto 44px;

  @media only screen and (max-width: 640px) {
    padding: 50px 40px;
  }
`

export const Title = styled.h4`
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
  color: #937251;
`

export const BoldBasicTitle = styled.strong`
  margin-top: 20px;
  display: block;
`;


export const ContentText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  margin-top: 24px;
`

export const FooterMessage = styled.small`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #7B7C82;
  margin-top: 80px;
`